import { environment } from './../environments/environment';
import { getLoader } from '@ipreo/nmp-loader';

import * as tslib from 'tslib';
import * as angularCdk from '@angular/cdk';
import * as angularCore from '@angular/core';
import * as angularCommon from '@angular/common';
import * as angularAnimations from '@angular/animations';
import * as angularAnimationsBrowser from '@angular/animations/browser';
import * as angularCommonHttp from '@angular/common/http';
import * as angularForms from '@angular/forms';
import * as angularPlatformBrowserAnimations from '@angular/platform-browser/animations';
import * as angularPlatformBrowserDynamic from '@angular/platform-browser-dynamic';
import * as angularPlatformBrowser from '@angular/platform-browser';
import * as angularRouter from '@angular/router';
import * as angularCompiler from '@angular/compiler';
import * as rxjs from 'rxjs';
import * as moment from 'moment';
import * as rxjsOperators from 'rxjs/operators';
import * as northstar from '@ipreo/northstar';
import * as ngrxStore from '@ngrx/store';
import * as ngrxEffects from '@ngrx/effects';
import * as ngrxRouterStore from '@ngrx/router-store';
import * as sprinkles from '@ipreo/ngx-sprinkles';
import * as cupcakeComponents from '@ipreo/cupcake-components';
import * as oidcClient from 'oidc-client';
import * as ngxSlider from '@angular-slider/ngx-slider';
import * as agGridAngular from 'ag-grid-angular';
import * as agGridCommunity from 'ag-grid-community';
import * as agGridEnterprise from 'ag-grid-enterprise';

console.log('BOOT IT', environment);

getLoader(environment.registryUrl);

getLoader().register('tslib', tslib);
getLoader().register('@angular/cdk', angularCdk);
getLoader().register('@angular/core', angularCore);
getLoader().register('@angular/common', angularCommon);
getLoader().register('@angular/animations', angularAnimations);
getLoader().register('@angular/platform-browser', angularPlatformBrowser);
getLoader().register('@angular/router', angularRouter);
getLoader().register('@angular/compiler', angularCompiler);
getLoader().register('@angular/animations/browser', angularAnimationsBrowser);
getLoader().register('@angular/common/http', angularCommonHttp);
getLoader().register('@angular/forms', angularForms);
getLoader().register(
  '@angular/platform-browser/animations',
  angularPlatformBrowserAnimations
);
getLoader().register(
  '@angular/platform-browser-dynamic',
  angularPlatformBrowserDynamic
);
getLoader().register('rxjs', rxjs);
getLoader().register('rxjs/operators', rxjsOperators);
getLoader().register('moment', moment);
getLoader().register('@ipreo/cupcake-components', cupcakeComponents);
getLoader().register('@ipreo/northstar', northstar);
getLoader().register('@ipreo/ngx-sprinkles', sprinkles);
getLoader().register('@ngrx/store', ngrxStore);
getLoader().register('@ngrx/effects', ngrxEffects);
getLoader().register('@ngrx/router-store', ngrxRouterStore);
getLoader().register('oidc-client', oidcClient);
getLoader().register('@angular-slider/ngx-slider', ngxSlider);
getLoader().register('ag-grid-angular', agGridAngular);
getLoader().register('ag-grid-community', agGridCommunity);
getLoader().register('ag-grid-enterprise', agGridEnterprise);
